import en from './locale/en.json';
import pt_BR from './locale/pt_BR.json';

export default { en, pt_BR };
